import * as React from 'react'

import { cn } from '@/lib/utils'
import { useFieldProps } from './form-field'

/**
 * The checkbox (spec-64-u2, U-150 / U-202): the browser's own, 16 px, ticked in the action
 * tint. The browser draws its edge at ≥ 3:1 on white, unlike the warm card border that
 * hand-made boxes used (1.2:1).
 */
function Checkbox({ className, ...props }: Omit<React.ComponentProps<'input'>, 'type'>) {
  const fieldProps = useFieldProps(props)
  return (
    <input
      type="checkbox"
      data-slot="checkbox"
      className={cn('size-4 shrink-0 cursor-pointer accent-primary disabled:cursor-not-allowed', className)}
      {...fieldProps}
    />
  )
}

export { Checkbox }
